import { render, staticRenderFns } from "./CommentNumberIcon.vue?vue&type=template&id=0516357a"
import script from "./CommentNumberIcon.vue?vue&type=script&lang=ts"
export * from "./CommentNumberIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports